import { Text } from '@fluentui/react';
import { useTheme } from '../../../../../../../Themes/themeContext';

export const TableHeader = ({ children }: { children: React.ReactNode; }) => {
    const theme = useTheme();
    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Text styles={{ root: { color: theme.semanticColors.bodyText, fontSize: 15, fontWeight: 600 } }}>{children}</Text>
        </div>
    );
};
